import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const deletePatientList = async (listID) => {
  const apiURL = API_HOST + '/patient_lists/' + listID;
  const { token, userID } = useCurrentUser();

  try {
    const { data } = await axios.delete(apiURL, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
      },
    });
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
